<template>
  <div class="main-content">
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>

    <div class="d-flex justify-content-between">
      <div>
        <div class="info-block">
          <h5 class="title">{{ $t("utils.table.name") }}</h5>
          <p class="value">{{ user.name }}</p>
        </div>

        <div class="info-block">
          <h5 class="title">Email</h5>
          <p class="value">{{ user.email }}</p>
        </div>

        <div class="info-block">
          <h5 class="title">
            {{ $t("dashboard.superadmin.users.registration-date") }}
          </h5>
          <p class="value">
            {{ $moment(user.createdAt).format("DD/MM/YYYY") }}
          </p>
        </div>

        <div class="info-block">
          <h5 class="title">{{ $t("utils.age") }}</h5>
          <p class="value">{{ user.age }}</p>
        </div>

        <div class="info-block">
          <h5 class="title">{{ $t("sidebar.actions.status-label") }}</h5>
          <p class="value">{{ user.banned ? "Banned" : "Active" }}</p>
        </div>
      </div>

      <div>
        <button
          class="btn btn-primary px-5"
          v-if="!user.banned"
          @click="banUser()"
        >
          Ban User
        </button>
        <button class="btn btn-primary px-5" v-else @click="unbanUser()">
          Unban User
        </button>
      </div>
    </div>

    <MessageBanner
      :message="error"
      :type="'error'"
      :classes="['position-bottom-center']"
      v-if="error !== ''"
    />
  </div>
</template>

<script>
import UserService from "@/services/user";

export default {
  data() {
    return {
      loading: false,
      user: null,
      error: ""
    };
  },

  methods: {
    async getUser() {
      this.loading = true;

      try {
        const { data } = await UserService.getUserById(this.$route.params.id);

        this.user = data;
      } catch (error) {
        this.error = error.response.data.message;

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    },

    async banUser() {
      this.loading = true;

      await UserService.banUser(this.user.id);

      this.getUser();
    },

    async unbanUser() {
      this.loading = true;

      await UserService.unbanUser(this.user.id);

      this.getUser();
    }
  },

  mounted() {
    this.$store.dispatch(
      "utils/setSectionName",
      this.$t("dashboard.superadmin.users-detail.title")
    );
    this.$store.dispatch("sidebar/setAction", null);

    this.getUser();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";
@import "src/assets/scss/buttons";

.info-block {
  margin-bottom: 23px;

  .title {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #252733;
  }

  .value {
    margin-bottom: 0;
    font-family: $mulish;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.3px;
    color: #252733;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superadmin/users/UserDetailPage.vue